import React from 'react';
import placeEnd from './page-end.svg'; // replace with the actual path to the SVG file

const EndImage = () => (
  <div style={{ display: 'flex', justifyContent: 'center' }}>
    <img src={placeEnd} alt="End" style={{ margin: '50px', width: '80px', height: '80px' }} /> {/* adjust size as needed */}
  </div>
);

export default EndImage;